<app-layout *ngIf="authService.isAuthenticated(); else guestContent">
  <router-outlet />
</app-layout>

<ng-template #guestContent>
  <router-outlet />
</ng-template>

<p-toast position="top-right" />
